import React, { FunctionComponent } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import Hint from 'src/ui/atoms/hint';

export interface DeleteGroupSuccessModalProps {
  onClose: () => void;
  group?: string;
}

const DeleteGroupSuccessModal: FunctionComponent<DeleteGroupSuccessModalProps> = (props) => {
  const { onClose } = props;

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="successfulDeleteGroupModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="successfulDeleteGroupModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              onClick: onClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteGroupSuccessModal;
